import { render, staticRenderFns } from "./AdminBulletin.vue?vue&type=template&id=18b5efc8&"
import script from "./AdminBulletin.vue?vue&type=script&lang=js&"
export * from "./AdminBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports